<div [ngClass]="{'rounded-3 border border-grey-300 bg-white p-lg': elevated}" *cftI18n="let t">
  <div class="mb-3xs flex items-center justify-between">
    <p role="heading" aria-level="2" class="heading-md">{{ t('contactFormCard.heading') }}</p>
    <img ngSrc="/assets/images/buildigo.svg" width="97" height="24" class="w-[97px] object-cover" alt="" />
  </div>
  <form [formGroup]="form | bgoAsFormGroup" (ngSubmit)="submit()">
    <cft-form-field>
      <label for="name">{{ t('contactFormCard.firstAndLastNameLabel') }}</label>
      <input id="name" type="text" [formControl]="controls.firstAndLastName | bgoAsFormControl" />
    </cft-form-field>
    <cft-form-field>
      <label for="email">{{ t('contactFormCard.emailLabel') }}</label>
      <input id="email" type="text" [formControl]="controls.email | bgoAsFormControl" />
    </cft-form-field>
    <cft-form-field>
      <label for="phoneNumber">{{ t('contactFormCard.phoneNumberLabel') }}</label>
      <input id="phoneNumber" type="text" [formControl]="controls.phoneNumber | bgoAsFormControl" />
    </cft-form-field>
    <cft-form-field class="h-full">
      <label for="message">{{ t('contactFormCard.messageLabel') }}</label>
      <textarea id="message" type="text" [formControl]="controls.message | bgoAsFormControl"></textarea>
    </cft-form-field>
    <div class="mt-md flex space-x-xs text-xs text-president-400">
      <fa-icon size="lg" [icon]="lockIcon"></fa-icon>
      <span [innerHTML]="t('contactFormCard.contactFormHint', {dataPrivacyLink})"></span>
    </div>
    @if (isSuccessful$ | async; as isSuccessful) {
      <button
        type="submit"
        class="mt-md btn w-full"
        cft-button
        [isLoading$]="isLoading$"
        [feedback$]="isSuccessful$"
        [successLabel]="t('contactFormCard.successMessageButtonLabel')"
        [ngClass]="{
          'btn-hero': isSuccessful === ButtonFeedback.None,
        }"
      >
        <span class="flex w-full space-x-sm">
          <span>{{ t('contactFormCard.sendMessageButtonLabel') }}</span>
          <fa-icon [icon]="submitIcon"></fa-icon>
        </span>
      </button>
    }
  </form>
  <div>
    <div class="my-md flex items-center space-x-lg">
      <div class="h-px flex-1 bg-grey-200"></div>
      <div class="text-sm font-bold text-grey-600">{{ alternativeCallToAction.alternativeCallToActionTitle }}</div>
      <div class="h-px flex-1 bg-grey-200"></div>
    </div>
    <div class="flex justify-between xl:space-x-sm">
      <cft-call-to-action
        class="hidden flex-1 xl:block"
        [showIcon]="false"
        [callToAction]="alternativeCallToAction.callToAction1"
        callToActionStyle="button-sm"
      >
      </cft-call-to-action>
      <cft-call-to-action class="flex-1" [showIcon]="true" [callToAction]="alternativeCallToAction.callToAction2">
      </cft-call-to-action>
    </div>
  </div>
</div>
